var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtstation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504.87 446.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.3,318.3c-6.03-10.27-11.86-20.66-17.77-31-49.75-87.02-99.45-174.07-149.3-261.03-8.23-14.35-20.76-23.13-37.29-25.27-15.68-2.03-31.49-.24-44.29-.81-16.5,0-30.06,0-43.62,0-7.23,0-7.31,.13-3.78,6.26,27.68,48.14,55.37,96.26,83.04,144.4,55.25,96.12,110.49,192.24,165.73,288.37q3.97,6.91,8.01-.06c13.03-22.53,26.17-44.98,39.04-67.6,10.01-17.61,10.72-35.42,.24-53.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.93,349.94c-2.44-4.3-5.19-5.67-9.98-5.66-49.84,.16-99.68,.1-149.52,.1-50.39,0-100.78,0-151.17,0-6.28,0-6.35,.08-3.28,5.41,13.28,23.01,26.72,45.93,39.85,69.02,10.47,18.42,26.25,27.75,47.23,27.78,91.8,.13,183.6,.06,275.4,.05,6.75,0,6.95-.35,3.57-6.2-17.39-30.16-34.9-60.24-52.1-90.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.29,271.8c72.19,0,144.38,0,216.56,0,6.83,0,6.83-.04,3.33-6.1-33.71-58.38-67.42-116.77-101.14-175.15-3.27-5.66-6.58-11.3-10.23-17.56-1.37,2.02-2.35,3.3-3.15,4.68-36.28,62.82-72.55,125.66-108.81,188.49-3.23,5.59-3.2,5.63,3.43,5.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtstation);
export default __webpack_public_path__ + "static/media/artstation.3889ded3f8a229c421b0459961191ce4.svg";
export { ForwardRef as ReactComponent };